import { Component, inject, Injector, signal, Type, ViewEncapsulation, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { NgClass, NgComponentOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { DIALOG_DATA, DialogData, DialogIcon } from '@ui/dialog-v2/dialog.tokens';
import { ButtonModule } from '@ui/form/button/button.module';
import { IconBsComponent } from '@ui/elements/icon-bs/icon-bs.component';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';
import { RxEffects } from '@rx-angular/state/effects';


@Component({
    selector: 'ui-dialog-v2',
    imports: [
        MatDialogContent,
        NgComponentOutlet,
        TranslatePipe,
        ButtonModule,
        IconBsComponent,
        MatDialogClose,
        NgClass,
    ],
    templateUrl: './dialog-v2.html',
    styleUrl: './dialog-v2.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'mp-dialog',
    },
    providers: [RxEffects],
})
export class DialogV2 {
    readonly #injector: Injector = inject(Injector);
    readonly #dialogRef: MatDialogRef<DialogV2> = inject(MatDialogRef);
    readonly #data: DialogData = inject(MAT_DIALOG_DATA);

    public readonly title: WritableSignal<string> = signal<string>(null);
    public readonly description: WritableSignal<string> = signal<string>(null);
    public readonly icon: WritableSignal<DialogIcon> = signal<DialogIcon>(null);
    public readonly dialogContentPaddingClass: WritableSignal<string> = signal<string>('px-md-6 px-3 w-100');

    public injectorData: Injector;
    public component: Type<any>;

    constructor() {
        if (this.#data?.params?.title) {
            this.title.set(this.#data.params.title);
        }

        if (this.#data?.params?.description) {
            this.description.set(this.#data.params.description);
        }

        if (this.#data?.params?.dialogContentPaddingClass) {
            this.dialogContentPaddingClass.set(this.#data.params.dialogContentPaddingClass);
        }

        if (this.#data?.params?.icon) {
            this.icon.set(this.#data.params.icon);
        }



        this.component = this.#data.component;
        this.injectorData = Injector.create({
            providers: [
                {
                    provide: DIALOG_DATA,
                    useValue: {
                        ...this.#data?.params,
                        ...{ dialogRef: this.#dialogRef },
                    },
                },
            ],
            parent: this.#injector,
        });
    }

    protected readonly bsIconTypes: typeof BsIconTypes = BsIconTypes;
}
